import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

export type AdminStateMode = 'loading' | 'empty' | 'error' | 'success';

@Component({
  selector: 'app-admin-state-panel',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule],
  templateUrl: './admin-state-panel.component.html',
  styleUrl: './admin-state-panel.component.scss',
})
export class AdminStatePanelComponent {
  @Input() mode: AdminStateMode = 'empty';
  @Input() titleKey = '';
  @Input() descriptionKey = '';
  @Input() retryLabelKey = 'COMMON.RETRY';
  @Input() showRetry = false;

  @Output() retry = new EventEmitter<void>();

  get iconClass(): string {
    switch (this.mode) {
      case 'loading':
        return 'fas fa-spinner fa-spin';
      case 'error':
        return 'fas fa-triangle-exclamation';
      case 'success':
        return 'fas fa-circle-check';
      default:
        return 'fas fa-inbox';
    }
  }
}
